export default __webpack_public_path__ + "static/thumb-landscape-543d91baec867ab9e970bd3d4809eadc.jpg";